import { Render } from "../render/Render";
import { useSession } from "../lib/session";

export function Invoices() {
  const { session } = useSession();
  type Elem = { type: string; props: Record<string, unknown>; children: string[] };
  const elements: Record<string, Elem> = {
    root: {
      type: "Page",
      props: {
        title: "Invoices",
        subtitle: session.activeOutletId
          ? `Outlet ${session.activeOutletId} — soon: OCR ingestion + Xero / QB export`
          : "Pick an outlet first.",
      },
      children: ["coming"],
    },
    coming: {
      type: "EmptyState",
      props: {
        title: "Invoice intake — coming soon",
        body: "Observed endpoints under zm-invoicemanagement.zeemart.co are mapped in docs/zeemart-api.md. The buyer.zeemart.co Invoices screen wires up the OCR review + paid-status flow; this rebuild will pick up there next.",
      },
      children: [],
    },
  };
  return <Render spec={{ root: "root", elements } as never} />;
}
